import Partner1 from "../img/partner/oracle.jpg";
import partner2 from "../img/partner/microsoft.png";
import Partner3 from "../img/Brands/servicenow.png";
import Partner4 from "../img/partner/zoho-partner.png";
import Partner5 from "../img/partner/tally.png";

export const PartnerDetails = [
  {
    image: Partner3,
    title: "ServiceNow Partner",
    
    desc: `
Consulting & Implementation
Authorized to perform end-to-end Implementation of ServiceNow AI Platform.\n
Build Partner
Development of SN Store applications that bring additional platform value for SN customers.`,
  },
  {
    image: partner2,
    title: "Microsoft Cloud Solution Provider",
    desc: `Allows to migrate apps into Azure Cloud, build new apps in Azure, Power BI platforms.`,
  },

  {
    image: Partner1,
    title: "Oracle NetSuite SDN Partner",
    desc: `
           Oracle NetSuite SDN Partner offering Oracle NetSuite customization, ongoing support and add-on apps.`,
  },
  {
    image: Partner4,
    title: "Zoho Authorized Partner",
    desc: `Zoho Partner offering end-to-end implementation of Zoho One, Zoho CRM, Zoho Books and build Zoho extensions.`,
  },
  {
    image: Partner5,
    title: "Tally Partner",
    desc: `Tally Partner for Sales and Solution, GVLA (Government, Very Large Account) for the past 15 years (since 2010).`,
  },
];
